import { render, staticRenderFns } from "./RowStatDisplay.vue?vue&type=template&id=f2014dac&scoped=true"
import script from "./RowStatDisplay.vue?vue&type=script&lang=js"
export * from "./RowStatDisplay.vue?vue&type=script&lang=js"
import style0 from "./RowStatDisplay.vue?vue&type=style&index=0&id=f2014dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2014dac",
  null
  
)

export default component.exports